import React from 'react';

const CardsContext = React.createContext();

export default CardsContext;